/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypePrelevement } from './TypePrelevement';
import {
    TypePrelevementFromJSON,
    TypePrelevementFromJSONTyped,
    TypePrelevementToJSON,
    TypePrelevementToJSONTyped,
} from './TypePrelevement';
import type { TypeEcheance } from './TypeEcheance';
import {
    TypeEcheanceFromJSON,
    TypeEcheanceFromJSONTyped,
    TypeEcheanceToJSON,
    TypeEcheanceToJSONTyped,
} from './TypeEcheance';
import type { TarificationBeneficiaireDto } from './TarificationBeneficiaireDto';
import {
    TarificationBeneficiaireDtoFromJSON,
    TarificationBeneficiaireDtoFromJSONTyped,
    TarificationBeneficiaireDtoToJSON,
    TarificationBeneficiaireDtoToJSONTyped,
} from './TarificationBeneficiaireDto';

/**
 * Détail de tarification d'un frais.
 * @export
 * @interface FraisTarifDto
 */
export interface FraisTarifDto {
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    fraisId?: string;
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    natureCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FraisTarifDto
     */
    montantUnitaireHT?: number;
    /**
     * 
     * @type {number}
     * @memberof FraisTarifDto
     */
    montantHT?: number;
    /**
     * 
     * @type {number}
     * @memberof FraisTarifDto
     */
    taxe?: number;
    /**
     * 
     * @type {number}
     * @memberof FraisTarifDto
     */
    montantTTC?: number;
    /**
     * 
     * @type {TypePrelevement}
     * @memberof FraisTarifDto
     */
    typePrelevement?: TypePrelevement;
    /**
     * 
     * @type {TypeEcheance}
     * @memberof FraisTarifDto
     */
    typeEcheance?: TypeEcheance;
    /**
     * 
     * @type {number}
     * @memberof FraisTarifDto
     */
    nombrePrelevements?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    taxeId?: string | null;
    /**
     * 
     * @type {TarificationBeneficiaireDto}
     * @memberof FraisTarifDto
     */
    beneficiaire?: TarificationBeneficiaireDto;
    /**
     * 
     * @type {string}
     * @memberof FraisTarifDto
     */
    compteBancaireId?: string | null;
}



/**
 * Check if a given object implements the FraisTarifDto interface.
 */
export function instanceOfFraisTarifDto(value: object): value is FraisTarifDto {
    return true;
}

export function FraisTarifDtoFromJSON(json: any): FraisTarifDto {
    return FraisTarifDtoFromJSONTyped(json, false);
}

export function FraisTarifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraisTarifDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fraisId': json['fraisId'] == null ? undefined : json['fraisId'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'natureCode': json['natureCode'] == null ? undefined : json['natureCode'],
        'code': json['code'] == null ? undefined : json['code'],
        'montantUnitaireHT': json['montantUnitaireHT'] == null ? undefined : json['montantUnitaireHT'],
        'montantHT': json['montantHT'] == null ? undefined : json['montantHT'],
        'taxe': json['taxe'] == null ? undefined : json['taxe'],
        'montantTTC': json['montantTTC'] == null ? undefined : json['montantTTC'],
        'typePrelevement': json['typePrelevement'] == null ? undefined : TypePrelevementFromJSON(json['typePrelevement']),
        'typeEcheance': json['typeEcheance'] == null ? undefined : TypeEcheanceFromJSON(json['typeEcheance']),
        'nombrePrelevements': json['nombrePrelevements'] == null ? undefined : json['nombrePrelevements'],
        'taxeId': json['taxeId'] == null ? undefined : json['taxeId'],
        'beneficiaire': json['beneficiaire'] == null ? undefined : TarificationBeneficiaireDtoFromJSON(json['beneficiaire']),
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
    };
}

export function FraisTarifDtoToJSON(json: any): FraisTarifDto {
    return FraisTarifDtoToJSONTyped(json, false);
}

export function FraisTarifDtoToJSONTyped(value?: FraisTarifDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fraisId': value['fraisId'],
        'libelle': value['libelle'],
        'natureCode': value['natureCode'],
        'code': value['code'],
        'montantUnitaireHT': value['montantUnitaireHT'],
        'montantHT': value['montantHT'],
        'taxe': value['taxe'],
        'montantTTC': value['montantTTC'],
        'typePrelevement': TypePrelevementToJSON(value['typePrelevement']),
        'typeEcheance': TypeEcheanceToJSON(value['typeEcheance']),
        'nombrePrelevements': value['nombrePrelevements'],
        'taxeId': value['taxeId'],
        'beneficiaire': TarificationBeneficiaireDtoToJSON(value['beneficiaire']),
        'compteBancaireId': value['compteBancaireId'],
    };
}

